import React from 'react';
import classnames from 'classnames';

class SearchResultsListItem extends React.Component {
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    const { item, onClick } = this.props;
    if(onClick) onClick(item);
  }

  render(){
    const { item, selected } = this.props;
    const itemClass = classnames({
      "list-group-item": true,
      "search-result-item": true,
      "overflow-ellipsis": true,
      "selected": selected
    })
    return (
      <li onClick={this.handleClick} style={{minHeight:'28px'}} className={itemClass} title={item.displayName}>
        <i className={item.iconClass + ' icon-inline'}></i>{item.displayName}
      </li>
    )
  }
}

export default SearchResultsListItem;